module.exports = __webpack_public_path__ + "img/icon-iosC-1.3b14fa17.png";